import React, { useState, useMemo, useEffect } from "react";
import Layout from "../../layout/Layout";
import { ChevronRightIcon, PlusSmallIcon } from "@heroicons/react/24/outline";
import OptionInput from "../../input/optionInput/OptionInput";
import JobTable, { LinkCell, StatusPill } from "../../table/JobTable";
import uploadVactor from "../../../assets/svg/upload-vactor.svg";
import { Link, useLocation, useParams } from "react-router-dom";
import { BASE_URL_2 } from "../../../customHooks/config";
import axios from "axios";
import { toast } from "react-toastify";
import FeedBackDialog from "../../section/JobSection/FeedBackDialog";
import InterviewKitDialog from "../../section/JobSection/InterviewKitDialog";
import Spinner from "../../layout/loader/Spinner";

function Applicant() {
  const [page, setpage] = useState(true);
  const [rows, setRows] = useState([]);
  const { id } = useParams();
  const [filter, setFilter] = useState({});
  const [data, setData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [interviewKitData, setInterviewKitData] = useState(null);
  const [loadingStates, setLoadingStates] = useState({});
  const [interviewKitLoadingStates, setInterviewKitLoadingStates] = useState({});

  const [paginationData, setPaginationData] = useState({
    pageSize: 5,
    pageNumber: 1,
    next: false,
    previous: false,
    count: 0,
  });

  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const handleDialogOpen = (rowData) => {
    setSelectedRowData(rowData);
  };

  const handleDialogClose = () => {
    setSelectedRowData(null);
  };

  useEffect(() => {
    setLoading(true);
    let url = `${BASE_URL_2}job/vendor/applicant_lists/?job_id=${id}&page_size=${paginationData?.pageSize}&page=${paginationData?.pageNumber}`;
    if (filter?.stages?.param)
      url = `${BASE_URL_2}job/vendor/applicant_lists/?job_id=${id}&page_size=${paginationData?.pageSize}&page=${paginationData?.pageNumber}${filter?.stages?.param}`;
    // if(filter?.stages?.param) url  = `${BASE_URL_2}job/vendor/applicant_lists/?job_id=${id}&page_size=${paginationData?.pageSize}&page=${paginationData?.pageNumber}${filter?.stages?.param}`

    axios
      .get(url, { withCredentials: true })
      .then((res) => {
        const nums = res?.data?.data;
        setRows(nums?.results);
        setPaginationData({
          ...paginationData,
          count: nums?.count,
          next: nums?.next ? true : false,
          previous: nums?.previous ? true : false,
        });
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoading(false);
      });
  }, [paginationData.pageNumber, paginationData.pageSize, filter]);

  useEffect(() => {
    axios
      .get(`${BASE_URL_2}job/vendor/job_stages/?job_id=${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        const arr = [];
        for (const [key, value] of Object.entries(res?.data?.data)) {
          arr.push(value);
        }
        setData(arr);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);



  const handleClickFeedBack = (params) => {
   
    if(params?.view_count){
    setLoadingStates((prevLoadingStates) => ({ ...prevLoadingStates, [params.id]: true }));
    axios
      .get(`${BASE_URL_2}job/vendor/admin-feedback/?job_applicant_id=${params.id}`, {
        withCredentials: true,
      })
      .then((res) => {
       if(res?.data?.success) handleDialogOpen(res?.data?.data?.admin_feedback);
        setLoadingStates((prevLoadingStates) => ({ ...prevLoadingStates, [params.id]: false }));
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoadingStates((prevLoadingStates) => ({ ...prevLoadingStates, [params.id]: false }));
      });
    }
  }

  const handleClickScore = (params) => {
    if (params?.total_weightage !== null && params?.total_weightage !== undefined) {
      setInterviewKitLoadingStates((prevLoadingStates) => ({ ...prevLoadingStates, [params.id]: true }));
      axios
        .get(`${BASE_URL_2}job/vendor/applicant_interview_kit_response/?job_applicant_id=${params.id}`, {
          withCredentials: true,
        })
        .then((res) => {
          if (res?.data?.success && res?.data?.data) {
            setInterviewKitData(res?.data?.data);
          } else {
            toast.error("No interview kit data available");
          }
          setInterviewKitLoadingStates((prevLoadingStates) => ({ ...prevLoadingStates, [params.id]: false }));
        })
        .catch((err) => {
          toast.error(err?.data?.error || "Failed to fetch interview kit response");
          setInterviewKitLoadingStates((prevLoadingStates) => ({ ...prevLoadingStates, [params.id]: false }));
        });
    }
  }

  const handleInterviewKitDialogClose = () => {
    setInterviewKitData(null);
  };


  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        width: 60,
        accessor: "sr_no",
      },
      {
        Header: "Candidate Name",
        width: 150,
        accessor: "candidate_name",
      },
      {
        Header: "Candidate Email",
        width: 200,
        accessor: "email",
      },
      {
        Header: "Work Experience",
        width: 120,
        accessor: "work_exp",
      },
      {
        Header: "Current CTC",
        width: 130,
        accessor: "curr_ctc",
      },
      {
        Header: "Expected CTC",
        width: 130,
        accessor: "expected_ctc",
      },
      {
        Header: "Current Location",
        width: 120,
        accessor: "current_city",
      },
      {
        Header: "Resume",
        width: 130,
        accessor: "resume",
        Cell: ({ row }) => (
          <Link
            style={{ color: "#2563EB", textDecoration: "underline" }}
            target="_blank"
            to={`${row.original.resume}`}
          >
            View
          </Link>
        ),
        linkAccessor: "link",
      },

      {
        Header: "Stages",
        width: 130,
        Cell: ({ row }) => (
          <>
            <StatusPill value={row.original.status_name} />
          </>
        ),
        accessor: "stages",
      },
      {
        Header: "Interview Score",
        width: 110,
        Cell: ({ row }) => (
          row.original.total_weightage !== null && row.original.total_weightage !== undefined ? (
            <span className="inline-block px-3 py-1 rounded-full text-sm font-bold border border-[#22c55e] text-[#22c55e] bg-green-50">
              {row.original.total_weightage} pts
            </span>
          ) : (
            <span className="text-gray-400 text-sm">-</span>
          )
        ),
        accessor: "score",
      },
      {
        Header: "Interview Response",
        width: 120,
        Cell: ({ row }) => (
          row.original.total_weightage !== null && row.original.total_weightage !== undefined ? (
            <button
              className="h-[34px] px-3 bg-white border border-[#2563EB] rounded-md text-sm text-[#2563EB] hover:bg-blue-50"
              onClick={() => handleClickScore(row.original)}
            >
              {interviewKitLoadingStates[row.original.id] ? <Spinner /> : "View"}
            </button>
          ) : (
            <span className="text-gray-400 text-sm">-</span>
          )
        ),
        accessor: "kit_response",
      },
      {
        Header: "Feedback",
        width: 130,
        Cell: ({ row }) => (
          <div>
            <button
              className=" h-[34px] px-3  bg-white border border-[#2563EB] rounded-md text-sm text-[#2563EB] "
              onClick={() => handleClickFeedBack(row.original)}
            >
              {loadingStates[row.original.id] ? <Spinner/> : `View(${row.original.view_count})`}

            </button>
          </div>
        ),
        accessor: "Feedback",
      },
    ],
    [loadingStates, interviewKitLoadingStates]
  );
  return (
    <>
      <div
        className="absolute top-[72px] mt-[5px] "
        style={{ fontFamily: "gilRoy-semibold" }}
      >
        <nav className="flex" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <a
                href="/all-jobs/1"
                className="inline-flex items-center text-xs font-medium text-[#6C757D] hover:text-blue-600 "
              >
                Job
              </a>
            </li>
            <li style={{ marginLeft: 0 }}>
              <div className="flex items-center">
                <ChevronRightIcon className="w-3 h-3" />

                <a
                  href="#"
                  className=" text-xs font-medium  text-[#6C757D] hover:text-blue-600"
                >
                  Applicant
                </a>
              </div>
            </li>
          </ol>
        </nav>
      </div>
      {page ? (
        <div className=" w-full flex  flex-col relative pt-4">
          <p className="my-4 text-lg  font-bold">
            <p className="inline text-[1.5rem] text-primary">
              {location?.state?.companyName}{" "}
            </p>{" "}
            {">"}{" "}
            <p className="inline text-[1.5rem] text-primary">
              {location?.state?.jobTitle}
            </p>
          </p>

          <div className=" w-full flex justify-between items-center">
            <div className="flex items-center ">
              <div className="mr-4">
                <h2 className="text-md  font-bold ">
                  Applicant ({paginationData?.count})
                </h2>
              </div>
              <div className="w-[200px]">
                <OptionInput
                  placeholder="Stages"
                  data={data}
                  filter={filter}
                  setFilter={setFilter}
                />
              </div>
            </div>

            <div>
              <Link to="/upload-candidate">
                <button className="btn-primary px-3 font-normal flex items-center ">
                  <PlusSmallIcon className="h-6 w-6 text-white " /> Upload
                  Candidates
                </button>
              </Link>
            </div>
          </div>
          <div className="mt-7">
            <JobTable
              columns={columns}
              data={rows}
              tableWidth="w-full"
              pagination="pagination"
              paginationData={paginationData}
              setPaginationData={setPaginationData}
              loading={loading}
              selectedRowData={selectedRowData}
              handleDialogClose={handleDialogClose}
            />
          </div>
          <InterviewKitDialog
            selectedRowData={interviewKitData}
            handleDialogClose={handleInterviewKitDialogClose}
          />
        </div>
      ) : (
        <div className="w-full h-full flex flex-col justify-center items-center  ">
          <img
            src={uploadVactor}
            className="aspect-square object-contain "
            alt="vactor"
          />

          <div>
            <Link to="/upload-candidate">
              <button className="btn-primary px-3 font-normal flex items-center ">
                <PlusSmallIcon className="h-6 w-6 text-white " /> Upload
                Candidates
              </button>
            </Link>
          </div>
        </div>
      )}

    </>
  );
}

export default Applicant;
